import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {   // 要设置的全局访问的state对象
  topNavIndex: 0,
  web: false,
  tips: false,                //提示框状态
  tipsTxt: '',                //提示框文本
  videoType: false,           //视频是否播放
  videoId: -1,                //视频id
  videoList: [
      require('@/assets/video/1.mp4'),
      require('@/assets/video/2.mp4'),
      require('@/assets/video/3.mp4'),
      require('@/assets/video/4.mp4'),
      require('@/assets/video/5.mp4'),
      require('@/assets/video/6.mp4'),
      require('@/assets/video/7.mp4'),
      require('@/assets/video/8.mp4'),
      require('@/assets/video/9.mp4'),
  ],              //视频列表
}
const mutations = {   // 实时监听state值的变化(最新状态)
  setNavIndex (state, payLoad) {  // 方法名随意,主要是用来承载变化的changableNum的值
    state.topNavIndex = payLoad.num
  },
  setWeb (state, type) {  // 方法名随意,主要是用来承载变化的changableNum的值
    state.web = type
  },
  setTips(state, tips) {
    for (var obj in tips) {
      if (obj == 'tips') {
        state.tips = tips.tips
      }
      if (obj == 'tipsTxt') {
        state.tipsTxt = tips.tipsTxt
      }
    }
  },
  setVideoPlay(state,video){
    state.videoType = video.videoType;
    state.videoId = video.videoId;
  },
  setVideoList(state,list){
    state.videoList = list;
  }
}
const actions  = {

}
const store = new Vuex.Store({
  state,
  mutations,
  actions
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js